module.exports = __webpack_public_path__ + "img/IMG-20200311-WA0056.0a1b5fde.jpg";